import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  CustomForm,
  CustomInput,
  CustomPassword,
} from "../../../shared/Input/AllInputs";
import PrimaryButton from "../../../shared/Button/PrimaryButton";
import {
  AddKey,
  getKeyList,
  updateKey,
} from "../../../redux/actions/profileAction";
import CustomCard from "../../../shared/Card/CustomCard";

const emptyForm = {
  apiKey: "",
  accountEmail: "",
  merchantCode: "",
  customPaymentLink: "",
};

export default function AddKeyForm({ type }) {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(emptyForm);
  const [isEditMode, setIsEditMode] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const { apiKey, accountEmail, merchantCode, customPaymentLink } = formData;
    if (!apiKey || !accountEmail || !merchantCode) return;

    const action = isEditMode ? updateKey : AddKey;
    const res = await dispatch(
      action({ apiKey, accountEmail, merchantCode, customPaymentLink }),
    );

    if (res?.success) {
      fetchKeyList();
    }
  };

  const fetchKeyList = () => {
    dispatch(
      getKeyList((res) => {
        if (res) {
          setFormData({
            apiKey: res.apiKey || "",
            accountEmail: res.accountEmail || "",
            merchantCode: res.merchantCode || "",
            customPaymentLink: res.customPaymentLink || "",
          });
          setIsEditMode(true);
        }
      }),
    );
  };

  useEffect(() => {
    fetchKeyList();
  }, []);

  return (
    <CustomCard>
      <CustomForm style={type === "VIEW" ? { pointerEvents: "none" } : {}}>
        <CustomPassword
          label="API Key"
          name="apiKey"
          value={formData.apiKey}
          onChange={handleChange}
          required
        />
        <CustomInput
          label="Account Email"
          name="accountEmail"
          value={formData.accountEmail}
          onChange={handleChange}
          required
        />
        <CustomInput
          label="Merchant Code"
          name="merchantCode"
          value={formData.merchantCode}
          onChange={handleChange}
          required
        />
        <CustomInput
          label="Custom Payment Link"
          name="customPaymentLink"
          value={formData.customPaymentLink}
          onChange={handleChange}
        />
      </CustomForm>
      <PrimaryButton
        type="button"
        label={isEditMode ? "Update" : "Save"}
        onClick={handleSubmit}
        extraClassName={"w-fit"}
      />
    </CustomCard>
  );
}
